import { Text } from 'react-native';
import { useLivePowerSyncQuery } from '~/powersync/hooks/useLivePowerSyncQuery';
import { db } from '@/lib/local-api';
import type { ChatMessagePartRecord } from '~/powersync/generated/schema';

export interface ChatRowPreviewProps {
  chatId: string;
}

/**
 * One-line preview of a chat's most recent text part, live-queried per row
 * (mirrors the `ChatMessage.Synced` pattern). Renders nothing until there is a
 * message, so a brand-new conversation shows only its title.
 */
export const ChatRowPreview = ({ chatId }: ChatRowPreviewProps) => {
  const { data } = useLivePowerSyncQuery<ChatMessagePartRecord>(
    db.Chat.queries.findLastTextPart(chatId),
    [chatId],
  );

  const text = data?.[0]?.text?.trim();
  if (!text) {
    return null;
  }

  return (
    <Text
      numberOfLines={1}
      className="text-[13px] font-inter-regular text-text-secondary"
    >
      {text}
    </Text>
  );
};
